import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../../constants/route'
import {
  useDateLocale,
  useNotification,
  useTimeZone,
} from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getViewingObjectName,
  performMockViewingArchive,
} from '../../../../RentalPortalViewing'
import { useViewingProfileContext } from '../useViewingProfileContext'

import ArchiveIcon from '../../../../../icons/delete.svg'

export function useViewingArchiveActions() {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleCloseModal, handleEntityReload, setModal, viewingData } =
    useViewingProfileContext()

  function handleArchive() {
    return performMockViewingArchive({ archived: true, id: viewingData?.id })
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification('Notification.CommonTitleArchivedKey')

        navigate(
          `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.viewings}`
        )
      })
      .catch(() => {
        handleCloseModal()

        handleAddErrorNotification('RentalPortal.ViewingArchiveUndoErrorKey')
      })
  }

  function handleRestore() {
    return performMockViewingArchive({ archived: false, id: viewingData?.id })
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification('Notification.CommonTitleRestoredKey')

        return handleEntityReload()
      })
      .catch(() => {
        handleCloseModal()

        handleAddErrorNotification('RentalPortal.ViewingArchiveUndoErrorKey')
      })
  }

  function openConfirmation({ isArchive }) {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: isArchive
            ? { beforeIconProps: { Icon: ArchiveIcon } }
            : undefined,
          submitText: t(
            isArchive
              ? 'RentalPortal.ViewingArchiveActionOptionKey'
              : 'RentalPortal.ListingRestoreActionOptionKey'
          ),
        }}
        description={t(
          isArchive
            ? 'RentalPortal.ViewingArchiveConfirmationTextKey'
            : 'RentalPortal.ViewingRestoreConfirmationTextKey',
          {
            name: getViewingObjectName({
              locale,
              t,
              timezone,
              viewing: viewingData,
            }),
          }
        )}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={isArchive ? handleArchive : handleRestore}
      />
    )
  }

  function handleClickArchive() {
    openConfirmation({ isArchive: true })
  }

  function handleClickRestore() {
    openConfirmation({ isArchive: false })
  }

  return { handleClickArchive, handleClickRestore }
}
